import { useMemo } from "react";

import { defineMessage, useIntl } from "react-intl";

import { ProductKeyTypes } from "@/libraries/wpl/foundations/src";

import { MobileNavCardProps } from "./mobile-nav-card";
import { MobileNavMenuPage } from "./mobile-nav-menu-page";

export const MobileNavProductDevelopers = ({
    productKey = "home"
}: {
    productKey?: ProductKeyTypes;
}) => {
    const intl = useIntl();

    function useProductsData(): Array<MobileNavCardProps> {
        return useMemo(() => {
            return [
                {
                    key: "jira",
                    logo: "jira",
                    href: "/software/jira",
                    name: "Jira",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.jira.description",
                            defaultMessage: "Flexible project management"
                        })
                    ),
                    isNew: false
                },
                {
                    key: "bitbucket",
                    logo: "bitbucket",
                    href: "/software/bitbucket",
                    name: "Bitbucket",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.bitbucket.description",
                            defaultMessage: "Collaborative code repos"
                        })
                    ),
                    isNew: false
                },
                {
                    key: "compass",
                    logo: "compass",
                    href: "/software/compass",
                    name: "Compass",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.compass.description",
                            defaultMessage: "Optimize software health"
                        })
                    ),
                    isNew: false
                }
            ];
        }, []);
    }

    const productsData = useProductsData();

    return (
        <MobileNavMenuPage
            pageLabel={intl.formatMessage({
                id: "globalnav.v2.productsDeveloper.title",
                defaultMessage: "Products for Developers"
            })}
            cards={productsData}
            productKey={productKey}
        />
    );
};
